import { FormBuilder, FormGroup, FormsModule, NgForm, Validators } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation, Inject, APP_INITIALIZER } from '@angular/core';
import { LoginServico } from '../servicos/login.servico';
import { Router, ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { config } from 'ngx-mask';
import { Config } from 'protractor';
import { ConfigApi } from '../shared/config-api.model';
import { ConfigUrlProvider } from '../shared/configurl-provider';
import { saveAs } from 'file-saver/FileSaver';

import { CustomValidators } from '../servicos/custom-validators';

declare var jquery: any;
declare var $: any;
declare var swal: any;

@Component({
    selector: 'app-login',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    LOGIN: any;
    Mostrar: any;
    private sub: any;

    DADOSESQUECEUSENHA: any;
    DADOSCADASTROSENHA: any;

    configApi: ConfigApi;
    recaptchaValido = false;
    conProcessos = {
        numeroProcesso: "",
        nomeInteressado: "",
        cpfInteressado: ""
    }

    customPatterns = {
        '0': { pattern: new RegExp('[0-9]') },
        '1': { pattern: new RegExp('[a-zA-Z0-9_.-]') },
    }

    CarregandoProcessos = false;
    processos = [];


    public userForm: FormGroup;
    public userFormCadastro: FormGroup;

    validacao_mensagens = {
        login: [{ type: 'required', message: 'CPF é requerido' }],
        senha: [{ type: 'required', message: 'Senha é requerido' }],
        CPF_CADASTRO: [{ type: 'required', message: 'este campo é requerido' }],
        RG_CADASTRO: [{ type: 'required', message: 'este campo é requerido' }],
        DATA_NASC_CADASTRO: [{ type: 'required', message: 'este campo é requerido' }],
        password: [{ type: 'required', message: 'A senha deve ter no minimo 6 caracteres e conter letras e numeros.' }],
        confirmPassword: [{ type: 'required', message: 'o campo confirmar senha precisa ser igual ao campo senha, o campo é requerido' }],
    };


    constructor(private http: Http,
        private httpClient: HttpClient,
        private loginServico: LoginServico,
        private router: Router,
        private configUrlProvider: ConfigUrlProvider,
        private formBuilder: FormBuilder,
        private fb: FormBuilder,
        private fbCadastro: FormBuilder) {
        this.configApi = this.configUrlProvider.getConfigApi();
        this.loadConfig();
        this.userForm = this.createSignupForm();
        this.userFormCadastro = this.createSignupFormCadastro();
    }


    createSignupForm(): FormGroup {
        return this.fb.group(
            {
                login: [null, Validators.required],
                senha: [null, Validators.required],
                CPF_CADASTRO: [null, null],
                DATA_NASC_CADASTRO: [null, null],
                CPF_ESQUECEUSENHA: [null, null],
                DATA_NASC_ESQUECEUSENHA: [null, null],
                NOVA: [null, null],
                CONFIRMA: [null, null]
            }
        );
    }

    createSignupFormCadastro(): FormGroup {
        return this.fbCadastro.group(
            {
                login: [null, null],
                senha: [null, null],
                CPF_CADASTRO: [null, Validators.required],
                RG_CADASTRO: [null, Validators.required],
                DATA_NASC_CADASTRO: [null, Validators.required],
                CPF_ESQUECEUSENHA: [null, null],
                DATA_NASC_ESQUECEUSENHA: [null, null],
                NOVA: [null, null],
                CONFIRMA: [null, null],
                password: [
                    null,
                    Validators.compose([
                        Validators.required,
                        // check whether the entered password has a number
                        CustomValidators.patternValidator(/\d/, {
                            hasNumber: true
                        }),
                        // check whether the entered password has upper case letter
                        CustomValidators.patternValidator(/[A-Za-z]/, {
                            hasCapitalCase: true
                        }),
                        // check whether the entered password has a lower case letter
                        //CustomValidators.patternValidator(/[a-z]/, {
                        //hasSmallCase: true
                        //}),
                        // check whether the entered password has a special character
                        // CustomValidators.patternValidator(
                        // /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
                        //{
                        //hasSpecialCharacters: true
                        // }
                        //),
                        Validators.minLength(6)
                    ])
                ],
                confirmPassword: [null, Validators.compose([Validators.required])]
            },
            {
                // check whether our password and confirm password match
                validator: CustomValidators.passwordMatchValidator
            }
        );
    }


    ngOnInit() {

        this.loginServico.logout();
        this.LOGIN = {};
        this.DADOSESQUECEUSENHA = {};
        this.DADOSCADASTROSENHA = {};
    }

    AcessarSistema() {
        this.Mostrar = true;
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
        let options = new RequestOptions({ headers: headers });
        this.http.post(this.sub + "/Login/Autenticar", JSON.stringify({ usuario: this.LOGIN.USUARIO, senha: this.LOGIN.SENHA }), options)
            .map((response: Response) => response.json())
            .subscribe(
                data => {
                    //console.log(data);
                    localStorage.setItem('DadosConfiguracoes', JSON.stringify(data));
                    localStorage.setItem('AcessoAdm', JSON.stringify(data));
                    this.router.navigate(['inicial']);
                    this.Mostrar = false;
                },
                error => {
                    this.Mostrar = false;
                    if (error.status == 0) {
                        swal({
                            title: "Atenção!",
                            type: "warning",
                            text: "Não foi possível conectar no servidor banco de dados!"
                        });
                    }
                    else {
                        swal({
                            title: "Atenção!",
                            type: "warning",
                            text: "Usuário não encontrado ou senha inválida!"
                        });
                    }
                }
            );
    }

    loadConfig() {
        this.sub = `${this.configApi.webApiUrl}/api`;
    }

    recaptchaResolved(captchaResponse: string) {
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
        let options = new RequestOptions({ headers: headers });
        this.http.post(`${this.sub}/Inicial/ValidaRecaptcha`, JSON.stringify({ gRecaptchaResponse: captchaResponse }), options)
            .subscribe(
                data => { this.recaptchaValido = true },
                error => { this.recaptchaValido = false }
            );
    }

    AbrirModalConsultaProcessos() {
        $("#ModalConsultaProcessos").modal('show');
    }

    ConsultarProcessos() {
        /*if (!this.recaptchaValido) {
            swal({
                title: "Atenção!",
                type: "warning",
                text: "Marque a opção 'Não sou um robô'!"
            });
            return;
        }*/

        console.log(this.conProcessos);
        this.CarregandoProcessos = true;

        this.processos = [];

        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
        let options = new RequestOptions({ headers: headers });

        this.http.post(this.sub + "/Login/GetProcessosTelaInicial", JSON.stringify(this.conProcessos), options)
            .map((response: Response) => response.json())
            .subscribe(
                data => {
                    if (data.resultado.length == 0) {
                        swal({
                            title: "Atenção!",
                            type: "warning",
                            text: "Nenhum processo encontrado"
                        });
                        return;
                    }

                    this.processos = data.resultado;

                    $("#ModalProcessos").modal('show');
                },
                error => {
                    swal({
                        title: "Atenção!",
                        type: "error",
                        text: "Nenhum processo encontrado"
                    });
                }
            )
            .add(() => this.CarregandoProcessos = false);
    }

    ExibeModal() {
        $("#ModalCadastro").modal('show');
        this.DADOSCADASTROSENHA.CPF = '';
        this.DADOSCADASTROSENHA.RG = '';
        this.DADOSCADASTROSENHA.DATA_NASC = '';
        this.DADOSCADASTROSENHA.NOVA = '';
        this.DADOSCADASTROSENHA.CONFIRMA = '';
    }
    ExibeModal2() {
        $("#ModalValidaEsqueciMinhaSenha").modal('show');
        this.DADOSCADASTROSENHA.CPF = '';
        this.DADOSCADASTROSENHA.RG = '';
        this.DADOSCADASTROSENHA.DATA_NASC = '';
        this.DADOSCADASTROSENHA.NOVA = '';
        this.DADOSCADASTROSENHA.CONFIRMA = '';
    }

    ValidasenhaMetodo() {

        if (this.DADOSCADASTROSENHA.CONFIRMA != this.DADOSCADASTROSENHA.NOVA) {
            return true
        }
        return false;
    }

    MensagemMetodo() {
        swal({
            title: "Atenção!",
            type: "warning",
            text: "As senhas digitadas não são iguais!"
        });
    }
    //trsta

    CadastrarNovaSenha() {
        var validpassword = this.userFormCadastro.get('password').valid;

        if (validpassword) {

            //this.validacao_mensagens.password.


            if (this.ValidasenhaMetodo()) {
                this.MensagemMetodo();
            }
            else {
                this.Mostrar = true;
                let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
                let options = new RequestOptions({ headers: headers });
                this.http.post(this.sub + "/Login/CadastrarNovaSenha", JSON.stringify({ cpf: this.DADOSCADASTROSENHA.CPF, rg: this.DADOSCADASTROSENHA.RG, DataNasc: this.DADOSCADASTROSENHA.DATA_NASC, senha: this.DADOSCADASTROSENHA.NOVA }), options)
                    .map((response: Response) => response.json())
                    .subscribe(
                        data => {
                            console.log(data);
                            this.Mostrar = false;
                            swal({
                                title: "Atenção!",
                                type: "success",
                                text: "Acesso criado com sucesso!"
                            });
                            $("#ModalCadastro").modal('hide');
                            this.DADOSCADASTROSENHA.CPF = '';
                            this.DADOSCADASTROSENHA.RG = '';
                            this.DADOSCADASTROSENHA.DATA_NASC = '';
                            this.DADOSCADASTROSENHA.NOVA = '';
                            this.DADOSCADASTROSENHA.CONFIRMA = '';

                        },
                        error => {
                            this.Mostrar = false;
                            if (error.status == 0) {
                                swal({
                                    title: "Atenção!",
                                    type: "warning",
                                    text: "Não foi possível conectar no servidor banco de dados!"
                                });
                            }
                            else {
                                $("#ModalCadastro").modal('hide');
                                $("#ModalEsqueciMinhaSenha").modal('show');
                            }
                        }
                    );
            }
        }
        else {
            swal({
                title: "Atenção!",
                type: "warning",
                text: "A senha deve ter no mínimo 6 caracteres e conter letras e números!"
            });
        }
    }

    ValidaAlteraSenha() {



        if (this.ValidasenhaMetodo()) {
            this.MensagemMetodo();
        }
        else {
            this.Mostrar = true;
            let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
            let options = new RequestOptions({ headers: headers });
            this.http.post(this.sub + "/Login/ValidaSenha", JSON.stringify({ cpf: this.DADOSCADASTROSENHA.CPF, rg: this.DADOSCADASTROSENHA.RG, DataNasc: this.DADOSCADASTROSENHA.DATA_NASC, senha: this.DADOSCADASTROSENHA.NOVA }), options)
                .map((response: Response) => response.json())
                .subscribe(
                    data => {
                        console.log(data);
                        this.Mostrar = false;

                        $("#ModalValidaEsqueciMinhaSenha").modal('hide');
                        $("#ModalSenha").modal('show');
                    },
                    error => {
                        this.Mostrar = false;
                        if (error.status == 0) {
                            swal({
                                title: "Atenção!",
                                type: "warning",
                                text: "Não foi possível conectar no servidor banco de dados!"
                            });
                        }
                        else {
                            $("#ModalValidaEsqueciMinhaSenha").modal('hide');
                            $("#ModalEsqueciMinhaSenha").modal('show');
                        }
                    }
                );
        }
    }

    ConfirmaSenha() {
        var validpassword = this.userFormCadastro.get('password').valid;

        if (validpassword) {
            if (this.ValidasenhaMetodo()) {
                this.MensagemMetodo();
            }
            else {
                this.Mostrar = true;


                let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
                let options = new RequestOptions({ headers: headers });
                this.http.post(this.sub + "/Login/ConfirmaSenha", JSON.stringify({ cpf: this.DADOSCADASTROSENHA.CPF, rg: this.DADOSCADASTROSENHA.RG, DataNasc: this.DADOSCADASTROSENHA.DATA_NASC, senha: this.DADOSCADASTROSENHA.NOVA }), options)
                    .map((response: Response) => response.json())
                    .subscribe(
                        data => {
                            console.log(data);
                            this.Mostrar = false;
                            swal({
                                title: "Atenção!",
                                type: "success",
                                text: "Senha Alterada com Sucesso!"
                            });
                            $("#ModalSenha").modal('hide');
                        },
                        error => {
                            this.Mostrar = false;
                            if (error.status == 0) {
                                swal({
                                    title: "Atenção!",
                                    type: "warning",
                                    text: "Não foi possível conectar no servidor banco de dados!"
                                });
                            }
                            else {
                                $("#ModalSenha").modal('hide');
                                $("#ModalEsqueciMinhaSenha").modal('show');
                            }
                        }
                    );
            }
        }
        else {
            swal({
                title: "Atenção!",
                type: "warning",
                text: "A senha deve ter no mínimo 6 caracteres e conter letras e números!"
            });
        }
    }

    VisualizarAcompanhamentoProcesso(processoBeneficioId: number, tipoProcesso: number) {
        this.CarregandoProcessos = true;
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        this.http.post(this.sub + "/Inicial/GetHistorico", JSON.stringify({ PROCESSO_ID: processoBeneficioId, TIPO_PROCESSO: tipoProcesso }), options)
            .map((response) => response.json())
            .subscribe(
                data => {
                    var file = new Blob([data], { type: 'application/pdf' });

                    if (window.navigator.msSaveOrOpenBlob) //IE & Edge
                    {
                        //msSaveBlob only available for IE & Edge
                        saveAs(file, "HistoricoProcesso.pdf");
                    }
                    else {
                        var fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    }
                },
                error => {
                    swal({
                        title: "Atenção!",
                        type: "warning",
                        text: "Acompanhamento de Processo não encontrado!"
                    });
                }
            )
            .add(() => this.CarregandoProcessos = false);
    }
}



// WEBPACK FOOTER //
// D:/Agents/amapa/_work/8/s/ANGULAR/src/app/login/login.component.ts